const Logos = [
	{
		id: '1',
		altTag: 'Payit Logo',
		srcName: 'payit-logo.svg',
	},
	{
		id: '2',
		altTag: 'Twitter Logo',
		srcName: 'twitter-logo.svg',
	},
	{
		id: '3',
		altTag: 'Devops Logo',
		srcName: 'devops-logo.svg',
	},
	{
		id: '4',
		altTag: 'Stackoverflow Logo',
		srcName: 'stackoverflow-logo.svg',
	},
	{
		id: '5',
		altTag: 'Unsplash Logo',
		srcName: 'unsplash-logo.svg',
	},
	{
		id: '6',
		altTag: 'Figma Logo',
		srcName: 'figma-logo.svg',
	},
];

export default Logos;
